import { List } from 'immutable';
import { isExternalOptionsField } from 'customer-data-filters-ui/utils/isExternalOptionsField';
import ExternalOptionEnumQuickFilterButton from './ExternalOptionEnumQuickFilterButton';
import FormattedMessage from 'I18n/components/FormattedMessage';
import In from 'customer-data-filters-ui/filterQueryFormat/operator/In';
import NotKnown from 'customer-data-filters-ui/filterQueryFormat/operator/NotKnown';
import QuickFilterSelectBase from './QuickFilterSelectBase';
import QuickFilterTooltip from './QuickFilterTooltip';
import ReferenceEnumQuickFilterButton from './ReferenceEnumQuickFilterButton';
import SimpleEnumQuickFilterButton from './SimpleEnumQuickFilterButton';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../../state/SegmentationFiltersInstanceContext';
import { isFieldRestricted } from '../../../utils/fieldLevelPermissions';
import { restrictedAsset, wrapWithRestrictedAssetTooltip } from '../utils/fieldLevelPermissionsUtilsForQuickFilters';
import TeamQuickFilterButton from './TeamQuickFilterButton';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { TEAM as TeamReferenceObjectType } from 'reference-resolvers/constants/ReferenceObjectTypes';
import { TEAM as TeamExternalOptionType } from 'customer-data-objects/externalOptions/ExternalOptionsReferenceTypes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getButtonComponent = (filterFamily, property, getIsUngated) => {
  if (property.referencedObjectType === TeamReferenceObjectType || property.externalOptionsReferenceType === TeamExternalOptionType) {
    return TeamQuickFilterButton;
  } else if (isExternalOptionsField(property, filterFamily, getIsUngated)) {
    return ExternalOptionEnumQuickFilterButton;
  } else if (property.options && property.options.size) {
    return SimpleEnumQuickFilterButton;
  } else {
    return ReferenceEnumQuickFilterButton;
  }
};
const isList = value => List.isList(value);
const parseConditionValue = condition => {
  if (isList(condition.value)) {
    return condition.value.toArray();
  }
  if (Array.isArray(condition.value)) {
    return condition.value;
  }
  return [condition.value];
};
const getStateFromCondition = condition => {
  if (!condition) {
    return {
      values: [],
      isUnassignedChecked: false,
      selectedOptionsCount: 0
    };
  }
  if (condition instanceof NotKnown) {
    return {
      values: [],
      isUnassignedChecked: true,
      selectedOptionsCount: 1
    };
  }
  const values = parseConditionValue(condition);
  return {
    values,
    isUnassignedChecked: false,
    selectedOptionsCount: values.length
  };
};
const EnumQuickFilter = ({
  buttonProperties,
  condition,
  disableTruncation,
  filterFamily,
  isFirst,
  property,
  onValueChange
}) => {
  const {
    values,
    isUnassignedChecked,
    selectedOptionsCount
  } = getStateFromCondition(condition);
  const isActive = selectedOptionsCount > 0;
  const isRestrictedField = isFieldRestricted(property.accessLevel);
  const {
    getIsUngated
  } = useContext(SegmentationFiltersInstanceContext);
  const onCheckboxChange = evt => {
    if (evt.target.checked) {
      onValueChange(NotKnown.of(property));
    } else {
      onValueChange();
    }
  };
  const onEnumValueChange = evt => {
    if (evt.target.value.length) {
      onValueChange(In.of(property, List(evt.target.value)));
    } else {
      onValueChange();
    }
  };
  const ButtonComponent = getButtonComponent(filterFamily, property, getIsUngated);
  const dropdownFooter = /*#__PURE__*/_jsx(Checkbox, {
    "data-selenium-test": "Quickfilters-checkbox-unassigned",
    checked: isUnassignedChecked,
    onChange: onCheckboxChange,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.quickFiltersBar.enum.unassigned"
    })
  });
  const getContent = () => {
    const {
      displayName
    } = property;
    if (isRestrictedField) {
      return /*#__PURE__*/_jsxs("span", {
        children: [restrictedAsset, displayName]
      });
    }
    if (!selectedOptionsCount) {
      return /*#__PURE__*/_jsx("span", {
        children: displayName
      });
    }
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.quickFiltersBar.enum.display",
      options: {
        propertyLabel: displayName,
        selectedOptionsCount
      }
    });
  };
  const renderButtonContent = () => {
    if (disableTruncation) {
      const contentWithoutTruncation = getContent();
      return isRestrictedField ? wrapWithRestrictedAssetTooltip(contentWithoutTruncation) : /*#__PURE__*/_jsx(QuickFilterTooltip, {
        condition: condition,
        property: property,
        children: contentWithoutTruncation
      });
    }
    const useTruncateStringTooltip = !isActive && !property.tooltip;
    const contentWithValue = /*#__PURE__*/_jsx(TruncateString, {
      maxWidth: buttonProperties.LABEL_MAX_WIDTH,
      tooltip: useTruncateStringTooltip && !isRestrictedField,
      children: getContent()
    });
    return isRestrictedField ? wrapWithRestrictedAssetTooltip(contentWithValue) : /*#__PURE__*/_jsx(QuickFilterTooltip, {
      condition: condition,
      disabled: useTruncateStringTooltip,
      property: property,
      children: contentWithValue
    });
  };
  return /*#__PURE__*/_jsx(QuickFilterSelectBase, {
    button: /*#__PURE__*/_jsx(ButtonComponent, {
      ButtonContent: renderButtonContent,
      buttonProperties: buttonProperties,
      dropdownFooter: dropdownFooter,
      filterFamily: filterFamily,
      isOptionsSelectDisabled: isUnassignedChecked,
      placement: isFirst ? 'bottom right' : 'bottom',
      property: property,
      value: values,
      onChange: onEnumValueChange
    }),
    buttonHeight: buttonProperties.BUTTON_HEIGHT,
    propertyName: property.name,
    isActive: isActive,
    onValueChange: onValueChange
  });
};
export default EnumQuickFilter;